export const onlyNumbers = (value, previousValue) => {
   if (!value) {
      return value
   }
   const onlyNums = value.replace(/[^\d]/g, '');
   return onlyNums;
};

// Allows only Numbers with optional 1 or 2 decimals  |  Added by Amit Sharma on 12/26/2019
export const onlyNumbersWithUpToTwoDecimals = (value) => {
   if (!value) {
      return value
   }

   if(value.indexOf(".") >= 0){ // Found . for decimal
      if((value.substr(value.indexOf("."),(value.indexOf(".")+1)))==='..' || (value.substr(value.indexOf("."),(value.indexOf(".")+1)))==='...'){
         value = value.substr(0,(value.indexOf(".")+1)); // only 1 instance of . preserved
      }else{
         value= (value.substr(0, value.indexOf(".")) + value.substr(value.indexOf("."), 3)) // only 2 digits after . preserved
      }
   }
   
   return value.replace(/[^\d.]/g, ''); // only digits and . preserved
};


// Converts the value input to string with only integers
export const toIntString = (value) => {
   if (!value) {
      return "";
   } else {
      const onlyNums = value.replace(/[^\d]/g, '');
      return onlyNums;
   }
};

// EXTENDS toIntString
// Removes leading zeros and handles possible overflow with string to int conversion
export const toIntStringCurrency = (value, previousValue) => {
   const intStr = toIntString(value);
   if (intStr.length > 0) {
      const parsedInt = parseInt(intStr);
      if (parsedInt === 0) {
         return "";
      } else if (parsedInt > Number.MAX_SAFE_INTEGER) {
         if (previousValue) {
            return parseInt(toIntString(previousValue)).toString();
         } else {
            return "";
         }
      } else {
         return parseInt(intStr).toString();
      }
   } else {
      return intStr;
   }
};